import '../css/WhyUsCard.css'

const WhyUsCard = ({img, title, subtitle}) => {
    return(
        <div className="why_us_card" style={{backgroundImage: `url('img/${img}')`}}>
            <div>{title}</div>
            <div>{subtitle}</div>
        </div>
    )
}

export default WhyUsCard;